import { SliderProps, Slider } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SliderStyled = styled(Slider)<SliderProps>(({ theme }) => ({
  '&.MuiSlider-thumb': {
    color: 'white',
    height: '15px',
    width: '15px',
    marginTop: '-5px',
    border: `1px solid ${theme.palette.border?.primary}`,
    '&.MuiSlider-active, &:hover.MuiSlider-active': {
      boxShadow: '0px 0px 0px 8px rgb(200 200 200 / 16%)',
    },
    '&.Mui-focusVisible, &:hover': {
      boxShadow: '0px 0px 0px 5px rgb(200 200 200 / 16%)',
    },
  },
  '&.MuiSlider-rail': {
    color: '#eeeeef',
    height: '5px',
    opacity: 1,
    borderRadius: '5px',
  },
  '&.MuiSlider-track': {
    color: '#eeeeef',
    height: '5px',
    opacity: 1,
    borderRadius: '5px',
  },
  '&.MuiSlider-colorPrimary': {
    color: theme.palette.primary.main,
  },
  '&.MuiSlider-colorSecondary': {
    color: theme.palette.secondary.main,
  },
  '&.MuiSlider-valueLabel': {
    color: '#333335',
  },
}));
